import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classnames from "classnames";
import _str from "shared/util/_str";
import Str from "shared/components/Str";
import Strf from "shared/components/Strf";
import PhoneInput from "shared/containers/PhoneInput";
import Terms from "shared/components/Sms/Terms";
import SmsStatus from "apps/login/components/screens/SmsStatus";
import useSendCode, { showSendCodeFeedbackBanner } from "shared/hooks/useSendCode";
import { trackSmsCodeSent } from "analytics/sms";
import { getLoginLink } from "apps/signup/util/constants";

import "./Sms.scss";

const EnterPhone = ({
	phoneNumber,
	dialingCode,
	handleSuccess,
	footer,
	showPhoneTakenError,
}) => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const { sendCode, canSendCode } = useSendCode();

	const createTokenAndSendCode = (completePhoneNumber) => {
		if (!canSendCode) {
			return;
		}

		setIsSubmitting(true);

		sendCode(completePhoneNumber)
			.then(() => {
				handleSuccess();
				trackSmsCodeSent({
					existingUser: false,
					countryCode: dialingCode,
				});
			})
			.catch(() => {
				showSendCodeFeedbackBanner();
				setIsSubmitting(false);
			});
	};

	const buttonText = isSubmitting ? _str("Submitting…") : _str("Next");

	return (
		<>
			<div className="sms-header">
				{!isSubmitting &&
					<span className="sms-header-title">
						<Str>What’s your phone number?</Str>
					</span>
				}
			</div>
			<div className="sms-fields-container">
				<>
					{!isSubmitting &&
						<form className="oknf oknf--gray sms-form">
							<div className={classnames("sms-fields", { "sms-fields-error": showPhoneTakenError })}>
								{showPhoneTakenError &&
									<Strf
										className="sms-fields-error-message"
										vars={{
											loginlink: (
												<Link
													to={`/logout?cf=${encodeURIComponent(getLoginLink())}`}
												>
													<Str>logging in</Str>
												</Link>
											),
										}}>
										This number is already in use. Use another number or try $loginlink.
									</Strf>
								}
								<PhoneInput />
							</div>

							<Terms />

							<div className="sms-actions">
								<input
									type="submit"
									value={buttonText}
									disabled={!canSendCode || !dialingCode || !phoneNumber || phoneNumber.length < 4}
									className={classnames("sms-actions-button", { "isSubmitting": isSubmitting })}
									onClick={(e) => {
										e.preventDefault();
										createTokenAndSendCode(`${dialingCode}${phoneNumber}`);
									}}
								/>
							</div>
						</form>
					}
					{isSubmitting &&
						<SmsStatus loading message={_str("Sending Code")} />
					}
				</>
			</div>
			{footer && !isSubmitting && footer}
		</>
	);
};

EnterPhone.propTypes = {
	handleSuccess: PropTypes.func.isRequired,
	dialingCode: PropTypes.string.isRequired,
	phoneNumber: PropTypes.string.isRequired,
	showPhoneTakenError: PropTypes.bool.isRequired,
	footer: PropTypes.element,
};

EnterPhone.defaultProps = {
	footer: null,
};

export default EnterPhone;






// WEBPACK FOOTER //
// ./src/shared/components/Sms/EnterPhone.jsx